const EstudioIcon = ({ color }) => {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.7262 18.7524C10.2212 19.0808 10.6458 19.2467 11 19.2499C11.3542 19.2552 11.7744 19.0883 12.2606 18.7524C12.7161 18.4152 13.1819 18.0787 13.651 17.7399C16.3497 15.7905 19.1563 13.7632 20.7305 11.0625H17.1875C16.7735 11.0625 16.4378 10.727 16.4375 10.313L16.4358 7.68477L9.38772 12.9748C9.16048 13.1454 8.85637 13.1729 8.60221 13.0459C8.34806 12.9189 8.1875 12.6591 8.1875 12.375V7.51034L5.88624 8.8929C5.76959 8.96298 5.63608 9 5.5 9H0.363363C1.47873 12.8081 4.99065 15.3372 8.49629 17.8618C8.90764 18.1581 9.3189 18.4543 9.7262 18.7524ZM0.0610401 7.5C0.0208338 7.1484 0 6.78646 0 6.41342C0 2.81035 2.662 0 6.05 0C7.964 0 9.801 0.944629 11 2.42522C12.199 0.944629 14.036 0 15.95 0C19.338 0 22 2.81035 22 6.41342C22 7.55888 21.799 8.60177 21.4429 9.5625H17.937L17.9348 6.18433C17.9346 5.90029 17.774 5.64072 17.5199 5.51382C17.2658 5.38693 16.9618 5.41447 16.7346 5.58498L9.6875 10.8743V6.18481C9.6875 5.91453 9.54207 5.66516 9.30684 5.53206C9.0716 5.39896 8.78294 5.40272 8.55126 5.54192L5.29203 7.5H0.0610401Z"
        fill={ color }
      />
    </svg>
  );
};

export default EstudioIcon;
